import { IColors } from '@interface/common.interface'
import './Icon.scss'

interface IIcon {
  /** A Bootstrap Icons name without the `bi-` prefix, e.g. "person-plus". An unknown name
   *  renders an empty glyph and no error, so check it exists in bootstrap-icons.css. */
  icon: string
  color?: IColors
  onClick?: any
  className?: string
  id?: string
  role?: string
  disabled?: boolean
  hoverTitle?: string
  style?: any
  size?: number
}

const Icon = ({ icon, color, onClick, className, id, role, disabled, hoverTitle, style, size }: IIcon) => (
  <i
    title={hoverTitle}
    onClick={onClick}
    className={`bi bi-${icon} noselect ${onClick ? 'icon' : ''} ${color ? 'text-' + color : ''} ${
      disabled ? 'icon_disabled' : ''
    } ${className || ''}`}
    id={id}
    role={role}
    aria-hidden={hoverTitle || role ? undefined : true}
    style={{ fontSize: size || '1.1rem', lineHeight: 1, ...style }}
  />
)

export default Icon
